import React from 'react';
import { Form, FormGroup, Col, Row, Button, InputGroup, FormControl, ControlLabel, Checkbox, Glyphicon } from 'react-bootstrap';
import Select from 'react-select';

import './style.scss';
import OrderItems from './OrderItems';
import constants, { WO_RELEASED } from '../util/constants';
import { WO_PRELIMINARY, ORDER_STATUS_ACTIVE, } from '../../components/util/constants';
import axios from 'axios';
import LoadingSpinner from '../LoadingSpinner';
import OrderTexts from './OrderTexts';
import { createOrderHeaderFromState } from './createOrderHeader';
import { createOrderItemsFromState } from './createOrderItems';
import _ from 'underscore';
import { Command } from './common';
import NPSpinnerModal from '../NPSpinnerModal';
import moment from 'moment';
import Dialog from 'react-bootstrap-dialog';
import ReactGA from 'react-ga';
import { hasGrant } from '../util/grantHelper';
import * as Grants from '../util/grants';
import * as orderUtil from '../util/order.helper'

class OrderCreate extends React.Component {

    constructor(props) {
        super(props);

        let clientCodes1 = [];
        let deliveryCodes = [];
        let currencies = [];
        if (props.clientCodeList != null || props.clientCodeList != undefined) {
            clientCodes1 = props.clientCodeList.ClientCodes.filter(d => d.MAIN_CLIENT === 1).map(d => ({
                label: d.CLIENT_CODE_REGIONAL + ' - ' + d.SHORT_NAME + this.addMinusAndStrIfStr(d.DELIVERY_DESTINATION),
                value: d
            }));
            deliveryCodes = props.clientCodeList.DeliveryCodes.map(d => ({
                label: d.CODE + ' - ' + d.DESCRIPTION,
                value: d
            }));
            currencies = props.clientCodeList.Currencies.map(d => ({
                label: d.CODE,
                value: d
            }));
        };

        //let data=this.loadData(props.cmd, props.id, props.itemId);//cmd={this.state.cmd} id={this.state.id} itemId
        this.state = {
            disabled: false,
            selectedCustomerValue: '',
            selectedEndUserValue: '',
            selectedShipToValue: '',
            selectedBillToValue: '',
            selectedSoldToValue: '',
            clientCodes: clientCodes1,
            subClientCodes: [],
            deliveryCodes,
            currencies,
            selectedDeliveryCodeValue: '',
            //selectedCurrencyValue: '',
            deliveryDestinationValue: '',
            vatValue: '',
            currencyValue: '',
            languageValue: '',
            paymentDescriptionValue: '',
            formatUnitValue: '',
            discountDescriptionValue: '',
            commentValue: '',
            selectedIMValue: '',
            productCodes: undefined,
            possibleTexts: [],
            possibleItemTexts: [],
            instructions: [],
            itemInstructions: [],
            orderItems: [],
            customerPO: '',
            isLoading: false,
            viewOrderTexts: false,
            callOffValue: false,
            viewOrderTexts: false,
            otherInfoCollapsed: true,
            viewOrderTextsCollapsed: true,
            oldmodificationDateTime: '',
            showSpinnerModal: false,
            setSaveOk: false,
            savedId: -1,
            oldInstructions: [],
            oldItemInstructions: [],
            cw_mark: false,
            fsc: false,
            pefc: false,
            legalEntity: '',
            userType: '',
            validationResult: {
                Validated: false,
                Errors: []
            },
            cancelledOrder: false,
            shipToCompany: '',
            shipToAddressLine1: '',
            shipToAddressLine2: '',
            shipToAddressLine3: '',
            shipToZip: '',
            shipToCity: '',
            shipToCountry: ''
        };

        this.close = this.close.bind(this);
        this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
        this.handleEndUserSelectChange = this.handleEndUserSelectChange.bind(this);
        this.handleSubClientSelectChange = this.handleSubClientSelectChange.bind(this);
        //this.handleDeliveryCodeSelectChange = this.handleDeliveryCodeSelectChange.bind(this);
        //this.handleCurrencySelectChange=this.handleCurrencySelectChange.bind(this);
        this.handleShipToSelectChange = this.handleShipToSelectChange.bind(this);
        this.getcombo = this.getcombo.bind(this);
        this.handleComboChange = this.handleComboChange.bind(this);
        this.getProductCodes = this.getProductCodes.bind(this);
        this.refresh = this.refresh.bind(this);
        this.notOkForRelease = this.notOkForRelease.bind(this);
        this.notOkToCancel = this.notOkToCancel.bind(this);
        this.getInstructions = this.getInstructions.bind(this);
        this.checkForPassiveClients = this.checkForPassiveClients.bind(this);
        this.sortProductCodes = this.sortProductCodes.bind(this);
        this.getLegalEntity = this.getLegalEntity.bind(this);
        // this.setShipToViewData = this.setShipToViewData.bind(this);
    }

    componentDidMount() {
        this.getLegalEntity();
        this.loadData(this.props.cmd, this.props.id, this.props.itemId, this);
    }

    getLegalEntity() {
        this.setState({ legalEntity: window.sessionStorage.getItem('LegalEntity'), userType: window.sessionStorage.getItem('UserType') });
    }

    NullOr0(value) {
        return !value || value < 0 || value == 0;
    }

    getNextWeekAsYYYYWW() {
        return moment().add(1, 'weeks').startOf('isoweek').format('YYYYWW');
    }

    setShipToViewData(clientCodeRegional) {
        if(clientCodeRegional)
        {
            const { API_BASE_URL } = constants;
            const header = {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            };
            axios.get(API_BASE_URL + `OrderEntry/GetClientAddress/?clientCodeRegional=${clientCodeRegional}`, { headers: header })
            .then(result => {
                const shipTo = result.data;
                this.setState({             
                shipToCompany: shipTo.COMPANY,
                shipToAddressLine1: shipTo.ADDR_LINE1,
                shipToAddressLine2: shipTo.ADDR_LINE2,
                shipToAddressLine3: shipTo.ADDR_LINE3,
                shipToZip: shipTo.ZIP,
                shipToCity: shipTo.CITY,
                shipToCountry: shipTo.COUNTRY_DESC })
            })
            .catch(error => {
                this.setState({ shipToViewData: {}})
            })
            

        }
    }

    notOkToCancel() {
        if(!this.props.id || this.props.id == '0' || this.state.copiedFromOrderNumber){
            return true;
        }
        let rows = this.state.orderItems;
        if(!rows || rows.length == 0){
            return true;
        }

        if(rows.every(x=>x.ORDER_ITEM_STATUS === WO_RELEASED || x.ORDER_ITEM_STATUS === WO_PRELIMINARY) == false){
            return true;
        }

        if(hasGrant(Grants.TYPES.Order_CancelReleased)){
            return false;
        }
        
        if(rows.some(x=>x.ORDER_ITEM_STATUS === WO_RELEASED)){
            return true;
        }

        return false;
    }

    notOkForRelease() {
        if (this.notOkToSave(this.state)) return true;
        let rows = this.state.orderItems;

        let wrongstatus = rows && rows.find(d => d &&
            ((this.NullOr0(d.QUANTITY) && this.NullOr0(d.WEIGHT)) || (hasGrant(Grants.TYPES.Order_EditPrice) && this.NullOr0(d.UNIT_PRICE_COMMITTED)) ||
                d.DELIVERYTIME_WEEK < this.getNextWeekAsYYYYWW()));
        return (!rows || rows.length == 0 || wrongstatus !== undefined);
    }

    addMinusAndStrIfStr(str) {
        return str !== null && str !== "" ? ' - ' + str : "";
    }

    setOrderInstructions(templateInstructions, instructions, isHeader) {

    }

    setOrderTexts(possibleTexts, texts, isHeader) {
        // console.log('possibleTexts',possibleTexts);
        // console.log('texts',texts);
        // console.log('isHeader',isHeader);
        possibleTexts.filter(pt => isHeader ? pt.FOR_HEADER == 1 : pt.FOR_DETAIL == 1).forEach(pt => {
            let test = texts.find(t => t.TEXT_CODE == pt.TEXT_CODE && t.TEXT_TYPE == pt.TEXT_TYPE);
            if (test) {
                //    console.log('setting selected',test);
                test.USERDEFINED = 0;
                test.SELECTED = 1;
                test[isHeader ? 'FOR_HEADER' : 'FOR_DETAIL'] = 1;
                test.IS_EDITABLE = pt.IS_EDITABLE;
                test.IS_VISIBLE = pt.IS_VISIBLE;
            }
            else {
                // Filtrera och ta bort om den finns med fel kod här
                pt.SELECTED = 0;
                // console.log('adding unselected',pt);
                texts.push(pt);
            }
        });

        let nrCustom = 1;
        texts.forEach(dt => {
            let test = possibleTexts.find(pt => dt.TEXT_CODE == pt.TEXT_CODE && dt.TEXT_TYPE == pt.TEXT_TYPE && (isHeader ? pt.FOR_HEADER == 1 : pt.FOR_DETAIL == 1));
            // console.log('test',test);
            if (!test) {
                dt.USERDEFINED = dt.TEXT_CODE.toUpperCase().startsWith("TCUST");
                dt.SELECTED = 1;
                //dt.TEXT_CODE = 'TCUST' + (nrCustom++).toString().padStart(2, '0');
                dt[isHeader ? 'FOR_HEADER' : 'FOR_DETAIL'] = 1;
            }
        });
        texts = _.sortBy(texts, 'SORT_INDEX').reverse();
        //console.log('texts',texts);
    }

    fixTexts(loaded, possible) {
        loaded.forEach(t => {
            let txt = possible.filter(f => f.TEXT_CODE == t.TEXT_CODE);
            if (txt.length = 1) {
                t.IS_EDITABLE = txt[0].IS_EDITABLE;
            }
        });
    }

    getDeliveryCodeLabel(enduser, customer) {
        let deliveryCode = enduser && enduser.value && enduser.value.DELIVERY_CODE
            ? this.getLabelAndValueForCodeAndDescription(enduser && enduser.value, this.state.deliveryCodes, "DELIVERY_CODE")
            : this.getLabelAndValueForCodeAndDescription(customer && customer.value, this.state.deliveryCodes, "DELIVERY_CODE");
        return deliveryCode && deliveryCode.label;
    }

    checkForPassiveClients(clientCodes, client) {
        let found = clientCodes.find(c => c.CLIENT_CODE_REGIONAL == client);
        return found;
    }

    getStateObjectForLoaded(data, self, cmd, orderItemNumber) {
        if (cmd < Command.CopyOne || cmd > Command.Modify) {
            throw ("getStateObjectForLoaded called with command=" + cmd);
        }
        if (cmd == Command.Modify && (data.ORDER_STATUS !== ORDER_STATUS_ACTIVE || data.Items.find(i => (i.ORDER_ITEM_STATUS !== WO_PRELIMINARY && i.ORDER_ITEM_STATUS !== WO_RELEASED)) !== undefined)) {
            throw ("getStateObjectForLoaded called with command=" + cmd + ' but order_status or order_item_status was not in the allowed state');
        }
        let result = {};
        Array.prototype.SelectMany = function (keyGetter) {
            return this.map(x => keyGetter(x)).reduce((a, b) => a.concat(b));
        }

        if (data && data.ORDER_NUMBER) {
            let cust = self.getClientFromString(self.props.clientCodeList.ClientCodes, data.CLIENT_CODE_REGIONAL, self);
            //let subClientCodes = cust && cust.value ? self.props.clientCodeList.ClientCodes.filter(d => (d.MAIN_CLIENT === 0 && d.CLIENT_CODE_REGIONAL.startsWith(cust.value.CLIENT_CODE_REGIONAL + '-')) || d === cust.value).map(d => (self.getLabelAndValueForClientCode(d))) : [];
            if (!cust || !cust.value) {
                this.dialog.show({
                    title: "Selected customer is not active.",
                    body: "This order contains a main customer which is not active, only orders with active customers are able to get cloned. Press OK to go back.",
                    actions: [
                        Dialog.OKAction(() => {
                            this.close();
                        })
                    ]

                });
                // this.dialog.showAlert('Selected customer is not active, cloning order is not possible.');
                // this.close();
                return null;
            }

            let clientCodes = cust && cust.value ? cust.value.END_USER_LIST.concat(cust.value.SHIP_TO_LIST, cust.value.SOLD_TO_LIST, cust.value.BILL_TO_LIST) : null;
            let subClientCodes = clientCodes ? clientCodes.map(d => (this.getLabelAndValueForClientCode(d))) : [];
            let endUserCodes = cust.value ? cust.value.END_USER_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];
            let shipToCodes = cust.value ? cust.value.SHIP_TO_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];
            let billToCodes = cust.value ? cust.value.BILL_TO_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];
            let soldToCodes = cust.value ? cust.value.SOLD_TO_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];

            let passiveCodes = new Array();
            if (!this.checkForPassiveClients(clientCodes, data.END_USER)) {
                passiveCodes.push('End user: ' + data.END_USER);
            }
            if (!this.checkForPassiveClients(clientCodes, data.CONTACT_CODE_BILL_TO)) {
                passiveCodes.push('Bill to: ' + data.CONTACT_CODE_BILL_TO);
            }
            if (!this.checkForPassiveClients(clientCodes, data.CONTACT_CODE_SHIP_TO)) {
                passiveCodes.push('Ship to: ' + data.CONTACT_CODE_SHIP_TO);
            }
            if (!this.checkForPassiveClients(clientCodes, data.CONTACT_CODE_SOLD_TO)) {
                passiveCodes.push('Sold to: ' + data.CONTACT_CODE_SOLD_TO);
            }

            if (passiveCodes !== null && passiveCodes.length > 0) {
                this.dialog.show({
                    title: 'Inactive customers for cloned order.',
                    body: passiveCodes.join(", ") + ', please select another option.',
                    actions: [
                        Dialog.OKAction(() => { })
                    ]
                });
            }

            if (cust.value.CLIENT_CODE_END_USER == null)
                cust.value.CLIENT_CODE_END_USER = cust.value.CLIENT_CODE_REGIONAL;
            let tmp = this.props.clientCodeList.PossibleTexts.filter(t =>
                ((t.CLIENT_CODE_REGIONAL === cust.value.CLIENT_CODE_REGIONAL && t.TEXT_TYPE == 0) || (t.CLIENT_CODE_REGIONAL === data.END_USER && t.TEXT_TYPE == 1)));


            let texts = tmp.filter(t => t.TEXT_TYPE == 0);
            let endTexts = tmp.filter(t => t.TEXT_TYPE == 1);

            endTexts.forEach(e =>
                texts.forEach(t => {
                    if (t.TEXT_CODE === e.TEXT_CODE && (e.FOR_DETAIL == t.FOR_DETAIL || e.FOR_HEADER == t.FOR_HEADER))
                        texts.splice(texts.indexOf(t), 1);
                }
                )
            );

            texts = texts.concat(endTexts);
            // texts.forEach(t=>{
            //     if(!data.Texts.includes(t))
            //         t.SELECTED = 0;
            // });

            let possibleItemTexts = texts.filter(t => t.FOR_DETAIL == 1);
            let possibleTexts = texts.filter(t => t.FOR_HEADER == 1);
            if (cmd != Command.Modify) {
                if (cmd == Command.CopyOne) {
                    data.Items = data.Items.filter(d => d.ORDER_ITEM_NUMBER == orderItemNumber);
                }
                else {
                    let test = data.Items.filter(d => d.ORDER_ITEM_NUMBER == orderItemNumber);
                    if (this.state.legalEntity === "NPBA")
                        data.Items = data.Items.filter(d => d.MILL_CODE == test[0].MILL_CODE);
                }
                data.AGENT_COMMENT = 'This order is copied from order ' + data.ORDER_NUMBER;
                data.COPIED_FROM_ORDER_NUMBER = data.ORDER_NUMBER;
                data.ORDER_NUMBER = -1;
                data.ORDER_STATUS = ORDER_STATUS_ACTIVE;
                data.Texts.forEach(t => t.ORDER_NUMBER = -1);
                data.Items.forEach(i => {
                    i.COPIED_FROM_ORDER_NUMBER = i.ORDER_NUMBER;
                    i.COPIED_FROM_ORDER_ITEM_NUMBER = i.ORDER_ITEM_NUMBER;
                    i.ORDER_NUMBER = -1;
                    i.ORDER_ITEM_NUMBER = -1;
                    i.ORDER_ITEM_STATUS = WO_PRELIMINARY;
                    i.DELIVERYTIME_METHOD = '4'
                    i.DATE_ISSUED = ''
                    i.DELIVERYTIME_WEEK = ''
                    i.Texts.forEach(t => {
                        t.ORDER_NUMBER = -1;
                        t.ORDER_ITEM_NUMBER = -1;
                    })
                });

            }

            // this.setOrderInstructions(data.Instructions, self.props.clientCodeList.Instructions,true);
            // data.Items.forEach(t=>{
            //     this.setOrderInstructions(t.Instructions,self.props.clientCodeList.Instructions,false);
            // });
            this.setOrderTexts(JSON.parse(JSON.stringify(texts)), data.Texts, true);
            data.Items.forEach(t => {
                this.setOrderTexts(JSON.parse(JSON.stringify(texts)), t.Texts, false);
            });
            let endUser = self.getClientFromString(clientCodes, data.END_USER, self);
            // let deliveryCode=endUser && endUser.value && endUser.value.DELIVERY_CODE  
            // ? this.getLabelAndValueForCodeAndDescription(endUser && endUser.value, this.state.deliveryCodes, "DELIVERY_CODE")
            // : this.getLabelAndValueForCodeAndDescription(cust && cust.value, this.state.deliveryCodes, "DELIVERY_CODE");

            result = {
                selectedCustomerValue: self.getClientFromString(self.props.clientCodeList.ClientCodes, data.CLIENT_CODE_REGIONAL, self),
                subClientCodes,
                endUserCodes,
                shipToCodes,
                billToCodes,
                soldToCodes,
                selectedEndUserValue: self.getClientFromString(clientCodes, data.END_USER, self),
                selectedShipToValue: self.getClientFromString(clientCodes, data.CONTACT_CODE_SHIP_TO, self),
                selectedBillToValue: self.getClientFromString(clientCodes, data.CONTACT_CODE_BILL_TO, self),
                selectedSoldToValue: self.getClientFromString(clientCodes, data.CONTACT_CODE_SOLD_TO, self),
                //selectedDeliveryCodeValue: deliveryCode && deliveryCode.label,
                selectedDeliveryCodeValue: self.getDeliveryCodeLabel(endUser, cust),
                //selectedDeliveryCodeValue: self.getLabelAndValueForCodeAndDescriptionFromString(data.DELIVERY_CODE, self.state.deliveryCodes),
                // selectedCurrencyValue: self.getLabelAndValueForCodeAndDescriptionFromString(data.CURRENCY_CODE,self.state.currencies, false),
                //////////////////////this.getLabelAndValueForCodeAndDescription(item&& item.value,this.state.currencies,"CURRENCY_CODE", false),
                deliveryDestinationValue: data.DELIVERY_DESTINATION,
                oldmodificationDateTime: data.MODUSER_DATETIME,
                vatValue: self.getFieldValue(cust && cust.value, 'REGISTRATION_NUMBER1'),
                currencyValue: this.getFieldValue(endUser && endUser.value, 'CURRENCY_CODE') || this.getFieldValue(cust && cust.value, 'CURRENCY_CODE'),
                languageValue: self.getFieldValue(cust && cust.value, 'LANGUAGE_CODE'),
                paymentDescriptionValue: self.getLabelForPaymentCode(endUser && endUser.value, cust && cust.value, self.props.clientCodeList.TermsOfPaymentCodes), //(item&&item.value,this.props.clientCodeList.TermsOfPaymentCodes)
                discountDescriptionValue: this.getdiscountDescriptionValue(endUser) || this.getdiscountDescriptionValue(cust),
                commentValue: data.AGENT_COMMENT,
                customerPO: data.CUSTOMER_PO,
                callOffValue: data.CALL_OFF == '1',
                salesAgentRef: data.SALES_AGENT_REF,
                //selectedFormatUnitValue: {label:data.FORMAT_UNIT,value:data.FORMAT_UNIT},
                formatUnitValue: data.FORMAT_UNIT || 'mm',
                possibleTexts: data.Texts,
                possibleItemTexts: possibleItemTexts,
                orderItems: data.Items,
                oldModUserDateTime: cmd == Command.Modify ? data.MODUSER_DATETIME : null,
                oldModUser: cmd == Command.Modify ? data.MODUSER : null,
                regUser: cmd == Command.Modify ? data.REGISTRATIONUSER : null,
                regUserDateTime: cmd == Command.Modify ? data.REGISTRATION_DATETIME : null,
                confirmationSent: cmd == Command.Modify ? data.CONFIRMATION_SENT == 1 : false,
                confirmation_Version: cmd == Command.Modify ? data.CONFIRMATION_VERSION : null,
                copiedFromOrderNumber: (cmd == Command.CopyAll || Command.CopyOne) ? data.COPIED_FROM_ORDER_NUMBER : null,
                instructions: this.getInstructions(1, endUser, cust),
                itemInstructions: this.getInstructions(0, endUser, cust),
                oldInstructions: JSON.parse(JSON.stringify(data.Instructions)),
                oldEndUser: endUser ? endUser.value.CLIENT_CODE_REGIONAL : data.END_USER,
                cw_mark: cust.value.CW_MARK,
                fsc: cust.value.FSC,
                pefc: cust.value.PEFC
                //oldItemInstructions:data.Items.
            };
        }
        //console.log('result from getStateObjectForLoaded', result);
        return result;
    }



    loadData(cmd, orderNumber, orderItemNumber, self) {
        if (orderNumber && orderNumber.length > 5 && cmd > Command.Create && cmd <= Command.Modify) {
            //self.setState({isLoading:true});
            const { API_BASE_URL } = constants;
            const header = {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            };
            let cloning = cmd == Command.CopyOne || cmd == Command.CopyAll;
            axios.get(API_BASE_URL + `OrderEntry/GetOrderDataForEntry/?orderNumber=${orderNumber}&cloning=${cloning}`, { headers: header })
                .then(result => {
                    try {
                        let data = this.getStateObjectForLoaded(result.data, self, cmd, orderItemNumber);

                        let pCodes = data && data.orderItems ? _.pluck(data.orderItems, 'PRODUCT_CODE').join("|") : "";
                        let disabled = data && data.orderItems ? data.orderItems.some(x => x.ORDER_ITEM_STATUS === 'B') : false;
                        data.disabled = disabled;
                        self.setState(data);
                        if (data && data.selectedCustomerValue && data.selectedCustomerValue.label && data.selectedCustomerValue.label.length > 2) {
                            setTimeout(function () {
                                self.getProductCodes(data.selectedCustomerValue.value.CLIENT_CODE_REGIONAL, pCodes, orderNumber, orderItemNumber)
                            }
                                , 400);
                        }

                        self.setShipToViewData(result.data.CONTACT_CODE_SHIP_TO);
                    }
                    catch (error) {
                        alert(error);
                        self.close();
                    }
                }
                ).catch(error => {
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    }
                    else {
                        console.log('no error.response');
                    }
                    self.setState({});
                    alert("Error getting order");
                    console.log("Error getting order", error);
                    self.close();
                });
        }
    }


    componentWillUnmount() {
        //alert("Returning");
    }

    close() {
        this.props.viewOrderCommand(this.state.cancelledOrder ? -1 : 0, (this.state.setSaveOk && (this.state.savedId > 0)) ? this.state.savedId : 0, 0);
        this.GAtrackHandler();
    }





    notOkToSave(state) {
        return (state.selectedCustomerValue == undefined || state.selectedEndUserValue == undefined || state.selectedBillToValue == undefined || state.selectedShipToValue == undefined ||
            state.orderItems == undefined || state.orderItems.length === 0 || (state.orderItems.find(oi => (oi.PRODUCT_CODE == undefined || oi.PRODUCT_CODE.length < 2) || oi.WEEK_OK == false || (oi.IS_PASSIVE === true || oi.IS_ACTIVE === false)) !== undefined));
    }
    

    showCancelDialog(self){
        self.dialog.show({
            title: "Cancel order",
            body: <div>Please beware:<br/>This action will cancel the order including all order items and it will no longer show up in this view. <br/>
                    Nordic Paper customer service can still access and see the order.</div>,
            actions: [
                Dialog.CancelAction(() => {
                    return;
                }),
                Dialog.OKAction((res) => {
                    self.cancelOrder(this);
                })
            ], 
            bsSize: 'medium'
        })
    }

    cancelOrder(self) {
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + self.props.apiToken,
            'Accept': 'application/octet-stream'
        };
        self.setState({ showSpinnerModal: true, saveInProgress: true, modalTitle: 'Cancelling order', modalContent: 'Order ' + self.props.id + ' successfully cancelled' });

        axios.post(API_BASE_URL + 'OrderEntry/CancelOrder', { OrderNumber: self.props.id, ModUserDateTime: self.state.oldModUserDateTime }, { headers: header })
            .then(result => {
                this.setState({ saveInProgress: false, setSaveOk: true, cancelledOrder: true });
            })
            .catch(error => {
                let msg = '';
                if (error.response.data) {
                    msg = error.response.data;
                }

                self.setState({ modalContent: 'Failed to cancel order ' + self.props.id + ', ' + msg, saveInProgress: false });
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }
            });
    }

    save(self, release) {
        const { API_BASE_URL } = constants;

        this.setState({ showSpinnerModal: true, saveInProgress: true });

        let oh = createOrderHeaderFromState(self.state, self.props.cmd, self.props.id);

        let or = createOrderItemsFromState(self.state, self.props.cmd);

        oh.Items = or;

        const header = {
            'Authorization': 'Bearer ' + self.props.apiToken,
            'Accept': 'application/octet-stream'
        };

        //GuiOrderHead guiOrder, bool release)
        axios.post(API_BASE_URL + 'OrderEntry/SaveOrder', { orderHead: oh, release: release }, { headers: header })
            .then(result => {

                let ordernum = result.data.OrderNumber;
                let answer = (oh.ORDER_NUMBER != -1 ? 'Modified order ' : 'Created order ') + ordernum.toString();
                let modalContent = null;
                if (result.data.Validation.Validated) {
                    modalContent = answer;
                }
                else {
                    modalContent = orderUtil.getValidationErrorContent(result.data.Validation.Errors, ordernum)
                }

                this.setState({ modalContent: modalContent, saveInProgress: false, setSaveOk: true, savedId: ordernum });

                this.GAtrackHandler(self, release);
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }

                this.setState({ modalContent: "An error occured during save, please try again later.", saveInProgress: false });
            });
    }

    sortProductCodes(codes) {
        //let codes = this.state.productCodes;
        codes.sort(function (a, b) {
            return a.PRODUCT_CODE.localeCompare(b.PRODUCT_CODE);
        });
        this.setState({ productCodes: codes });
    }

    getProductCodes(cc, pc, onum, oinum) {
        let self = this;
        self.setState({ productCodes: undefined });
        if (!cc) return;
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + this.props.apiToken,
            'Accept': 'application/octet-stream'
        };
        axios.get(API_BASE_URL + `OrderEntry/GetProducts/?clientCode=${cc}&prodCodes=${pc}&orderNumber=${onum}&orderItemNumber=-1`, { headers: header })
            .then(result => {
                this.sortProductCodes(result.data);

                // console.log("getProductCodes",result.data);
                //self.setState({ productCodes: result.data });
            }).catch(error => {
                alert("Error getting product codes");
                self.setState({ productCodes: [], isLoading: false });
            });
    }

    getLabelAndValueForClientCode(_value) {
        return (_value === undefined || _value === "") ? { label: '', value: null } : { label: _value.CLIENT_CODE_REGIONAL + ' - ' + _value.SHORT_NAME + this.addMinusAndStrIfStr(_value.DELIVERY_DESTINATION), value: _value };
    }

    getLabelForPaymentCode(_enduser, _client, paymentCodes) {
        return this.doGetLabelForPaymentCode(_enduser, paymentCodes) || this.doGetLabelForPaymentCode(_client, paymentCodes);
    }

    doGetLabelForPaymentCode(_value, paymentCodes) {
        if (_value === undefined || _value === "") return '';
        let tmp = paymentCodes.find(d => d.CODE === _value.TERMS_OF_PAYMENT_CODE && d.EXTRACODE === _value.LANGUAGE_CODE);
        tmp = tmp || paymentCodes.find(d => d.CODE === _value.TERMS_OF_PAYMENT_CODE && d.EXTRACODE === '*');
        return (tmp === undefined) ? null : tmp.CODE + ' - ' + tmp.DESCRIPTION;
    }

    getLabelAndValueForCodeAndDescription(_value, list, prop, IncludeDescription = true) {
        if (_value === undefined || _value === "") return { label: '', value: null }
        let codeForSearch = _value[prop];
        return this.getLabelAndValueForCodeAndDescriptionFromString(codeForSearch, list, IncludeDescription);
    }

    getLabelAndValueForCodeAndDescriptionFromString(codeForSearch, list, IncludeDescription = true) {
        let code = list.filter(d => d.value.CODE === codeForSearch).map(d => ({
            label: d.value.CODE + (IncludeDescription ? (' - ' + d.value.DESCRIPTION) : ''),
            value: d
        }))[0];
        return code;
    }

    getFieldValue(_value, _fieldname) {
        if (_value === undefined || _value === "") return '';
        return _value[_fieldname];
    }

    handleSubClientSelectChange(item, stateObj) {
        let newValue = this.state.selectedCustomerValue;
        if (item && item.value && item !== newValue) {
            newValue = this.getLabelAndValueForClientCode(item.value)
        }
        this.setState({ [stateObj]: newValue });
    }

    getInstructions(header, endUser, customer) {
        if (!this.props.clientCodeList || !this.props.clientCodeList.Instructions || !customer || !customer.value) return [];

        let inst = this.props.clientCodeList.Instructions.filter(t =>
            ((t.CLIENT_CODE_REGIONAL === customer.value.CLIENT_CODE_REGIONAL || (endUser && t.CLIENT_CODE_REGIONAL === endUser.value.CLIENT_CODE_REGIONAL))));

        if (endUser && customer.value.CLIENT_CODE_REGIONAL !== endUser.value.CLIENT_CODE_REGIONAL)
            inst = inst.filter(i => (i.INSTRUCTION_TYPE == 0 && i.CLIENT_CODE_REGIONAL == customer.value.CLIENT_CODE_REGIONAL) || (i.CLIENT_CODE_REGIONAL == endUser.value.CLIENT_CODE_REGIONAL && i.INSTRUCTION_TYPE == 1));
        return header ? JSON.parse(JSON.stringify(inst.filter(t => t.FOR_HEADER == 1))) : JSON.parse(JSON.stringify(inst.filter(t => t.FOR_DETAIL == 1)));
    }

    handleEndUserSelectChange(item, stateObj) {
        this.handleSubClientSelectChange(item, stateObj);
        let customer = this.state.selectedCustomerValue;
        let endUser = item;
        let newOrder = (!this.state.copiedFromOrderNumber && this.state.savedId == -1);
        // let deliveryCode=endUser && endUser.value && endUser.value.DELIVERY_CODE  
        // ? this.getLabelAndValueForCodeAndDescription(endUser && endUser.value, this.state.deliveryCodes, "DELIVERY_CODE")
        // : this.getLabelAndValueForCodeAndDescription(customer && customer.value, this.state.deliveryCodes, "DELIVERY_CODE");

        let currencyVal = this.getFieldValue(endUser && endUser.value, 'CURRENCY_CODE') || this.getFieldValue(customer && customer.value, 'CURRENCY_CODE');
        let instr = this.getInstructions(1, endUser, customer);
        instr = this.state.instructions.concat(instr.filter(i => i.INSTRUCTION_TYPE == 1));

        // TEXTER

        let endTexts = this.props.clientCodeList.PossibleTexts.filter(t =>
            (t.CLIENT_CODE_REGIONAL === endUser.value.CLIENT_CODE_REGIONAL && t.TEXT_TYPE == 1));
        let texts = [];

        texts = this.state.possibleTexts.concat(this.state.possibleItemTexts.filter(t => t.FOR_HEADER == 0));
        texts = texts.filter(t => t.TEXT_TYPE == 0);

        endTexts.forEach(e =>
            texts.forEach(t => {
                if (t.TEXT_CODE === e.TEXT_CODE && (e.FOR_DETAIL == t.FOR_DETAIL || e.FOR_HEADER == t.FOR_HEADER))
                    texts.splice(texts.indexOf(t), 1);
            }
            )
        );

        texts = texts.concat(endTexts);

        let possibleTexts = texts.filter(t => t.FOR_HEADER == 1);
        let possibleItemTexts = texts.filter(t => t.FOR_DETAIL == 1);
        // ITEM INSTRUKTIONER & TEXTER

        let itemInstr = this.getInstructions(0, endUser, customer);

        this.state.orderItems.forEach(oi => {
            if (oi.Instructions) {
                oi.Instructions = oi.Instructions.filter(i => i.INSTRUCTION_TYPE == 0);
                oi.Instructions = oi.Instructions.concat(itemInstr.filter(i => i.CLIENT_CODE_REGIONAL == endUser.value.CLIENT_CODE_REGIONAL && i.INSTRUCTION_TYPE == 1));
            }

            oi.CURRENCY_CODE = currencyVal;

            if (oi.Texts) {
                oi.Texts = oi.Texts.filter(t => t.TEXT_TYPE == 0);
                oi.Texts = oi.Texts.concat(texts.filter(t => t.TEXT_TYPE == 1 && t.FOR_DETAIL == 1));
            }
        });

        this.setState({
            selectedDeliveryCodeValue: this.getDeliveryCodeLabel(endUser, customer),
            currencyValue: currencyVal,
            paymentDescriptionValue: this.getLabelForPaymentCode(endUser && endUser.value, customer && customer.value, this.props.clientCodeList.TermsOfPaymentCodes),
            discountDescriptionValue: this.getdiscountDescriptionValue(endUser) || this.getdiscountDescriptionValue(customer),
            possibleTexts: JSON.parse(JSON.stringify(possibleTexts)),
            possibleItemTexts: JSON.parse(JSON.stringify(possibleItemTexts)),
            instructions: instr,
            itemInstructions: itemInstr
        });
    }

    handleComboChange(item, stateObj) {
        this.setState({ [stateObj]: item });
    }

    handleShipToSelectChange(item, stateObj) {
        this.handleSubClientSelectChange(item, stateObj);
        let tmp = this.getFieldValue(item && item.value, 'DELIVERY_DESTINATION');
        this.setState({ deliveryDestinationValue: tmp });
        this.setShipToViewData(item.value.CLIENT_CODE_REGIONAL);
    }

    getClientFromString(clientCodes, client, self) {
        let cl = clientCodes.find(c => c.CLIENT_CODE_REGIONAL == client);
        return cl && self.getLabelAndValueForClientCode(cl);
    }

    getClientCode(list, item, primaryProp, backupProp) {
        let tmp = list.find(s => (s.value.CLIENT_CODE_REGIONAL == item.value[primaryProp]));
        if (!tmp)
            tmp = item;
        return tmp;
    }

    handleClientSelectChange(item) {

        //console.log('OrderCreate handleClientSelectChange called');
        let clientCodes = item && item.value ? item.value.END_USER_LIST.concat(item.value.SHIP_TO_LIST, item.value.SOLD_TO_LIST, item.value.BILL_TO_LIST) : null;
        let subClientCodes = clientCodes ? clientCodes.map(d => (this.getLabelAndValueForClientCode(d))) : [];

        let endUserCodes = item.value ? item.value.END_USER_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];
        let shipToCodes = item.value ? item.value.SHIP_TO_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];
        let billToCodes = item.value ? item.value.BILL_TO_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];
        let soldToCodes = item.value ? item.value.SOLD_TO_LIST.map(d => (this.getLabelAndValueForClientCode(d))).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true })) : [];
        //let subClientCodes = item && item.value ? item.value.CLIENT_CODE_END_USER.concat(item.value.CLIENT_CODE_SHIP_TO, item.value.CLIENT_CODE_SOLD_TO, item.value.CLIENT_CODE_BILL_TO, 
        //  item.value.BILL_TO_LIST, item.value.END_USER_LIST, item.value.SHIP_TO_LIST, item.value.SOLD_TO_LIST) : [];
        let value = this.getLabelAndValueForClientCode(item && item.value);

        if (this.state.selectedCustomerValue && this.state.selectedCustomerValue.value.CLIENT_CODE_REGIONAL === item.value.CLIENT_CODE_REGIONAL) return;
        this.getProductCodes(item.value.CLIENT_CODE_REGIONAL, null, null);
        let shipTo = this.getClientCode(subClientCodes, item, 'CLIENT_CODE_SHIP_TO', 'CLIENT_CODE_REGIONAL'); //  subClientCodes.find(s=>s.value.CLIENT_CODE_REGIONAL==item.value.CLIENT_CODE_SHIP_TO)  ; 
        //let endUser=this.getClientCode(subClientCodes, item, 'CLIENT_CODE_END_USER', 'CLIENT_CODE_REGIONAL');//subClientCodes.find(s=>s.value.CLIENT_CODE_REGIONAL==item.value.CLIENT_CODE_END_USER); 
        if (item.value.CLIENT_CODE_END_USER == null)
            item.value.CLIENT_CODE_END_USER = item.value.CLIENT_CODE_REGIONAL;
        let tmp = this.props.clientCodeList.PossibleTexts.filter(t =>
            ((t.CLIENT_CODE_REGIONAL === item.value.CLIENT_CODE_REGIONAL && t.TEXT_TYPE == 0) || (t.CLIENT_CODE_REGIONAL === item.value.CLIENT_CODE_END_USER && t.TEXT_TYPE == 1)));

        let texts = tmp.filter(t => t.TEXT_TYPE == 0);
        let endTexts = tmp.filter(t => t.TEXT_TYPE == 1);

        endTexts.forEach(e =>
            texts.forEach(t => {
                if (t.TEXT_CODE === e.TEXT_CODE && (e.FOR_DETAIL == t.FOR_DETAIL || e.FOR_HEADER == t.FOR_HEADER))
                    texts.splice(texts.indexOf(t), 1);
            }
            )
        );

        texts = texts.concat(endTexts);

        let possibleTexts = texts.filter(t => t.FOR_HEADER == 1);
        let possibleItemTexts = texts.filter(t => t.FOR_DETAIL == 1);
        let endUser = this.getClientCode(subClientCodes, item, 'CLIENT_CODE_END_USER', 'CLIENT_CODE_REGIONAL');
        // console.log('item.value',item.value); 
        // let deliveryCode=endUser && endUser.value && endUser.value.DELIVERY_CODE  
        // ? this.getLabelAndValueForCodeAndDescription(endUser && endUser.value, this.state.deliveryCodes, "DELIVERY_CODE")
        // : this.getLabelAndValueForCodeAndDescription(item && item.value, this.state.deliveryCodes, "DELIVERY_CODE");
        const shipToValue = this.getClientCode(shipToCodes, item, 'CLIENT_CODE_SHIP_TO', 'CLIENT_CODE_REGIONAL');
        this.setShipToViewData(shipToValue.value.CLIENT_CODE_REGIONAL);

        this.setState({
            subClientCodes,
            endUserCodes,
            shipToCodes,
            billToCodes,
            soldToCodes,
            selectedCustomerValue: value,
            selectedEndUserValue: this.getClientCode(endUserCodes, item, 'CLIENT_CODE_END_USER', 'CLIENT_CODE_REGIONAL'),//subClientCodes.find(s=>s.value.CLIENT_CODE_REGIONAL==item.value.CLIENT_CODE_END_USER),
            selectedShipToValue: shipToValue,
            selectedBillToValue: this.getClientCode(billToCodes, item, 'CLIENT_CODE_BILL_TO', 'CLIENT_CODE_REGIONAL'),  //subClientCodes.find(s=>s.value.CLIENT_CODE_REGIONAL==item.value.CLIENT_CODE_BILL_TO),
            selectedSoldToValue: this.getClientCode(soldToCodes, item, 'CLIENT_CODE_SOLD_TO', 'CLIENT_CODE_REGIONAL'), //subClientCodes.find(s=>s.value.CLIENT_CODE_REGIONAL==item.value.CLIENT_CODE_SOLD_TO),
            selectedDeliveryCodeValue: this.getDeliveryCodeLabel(endUser, item),//deliveryCode && deliveryCode.label,
            //selectedCurrencyValue: this.getLabelAndValueForCodeAndDescription(item&& item.value,this.state.currencies,"CURRENCY_CODE", false),
            deliveryDestinationValue: this.getFieldValue(shipTo && shipTo.value, 'DELIVERY_DESTINATION'),
            vatValue: this.getFieldValue(item && item.value, 'REGISTRATION_NUMBER1'),
            currencyValue: this.getFieldValue(endUser && endUser.value, 'CURRENCY_CODE') || this.getFieldValue(item && item.value, 'CURRENCY_CODE'),
            languageValue: this.getFieldValue(item && item.value, 'LANGUAGE_CODE'),
            paymentDescriptionValue: this.getLabelForPaymentCode(endUser && endUser.value, item && item.value, this.props.clientCodeList.TermsOfPaymentCodes),
            discountDescriptionValue: this.getdiscountDescriptionValue(endUser) || this.getdiscountDescriptionValue(item),
            commentValue: '',
            selectedIMValue: '',
            salesAgentRef: '',
            customerPO: '',
            copiedFromOrderNumber: null,
            formatUnitValue: 'mm',
            //selectedFormatUnitValue: {label:'mm',value:'mm'},
            possibleTexts: JSON.parse(JSON.stringify(possibleTexts)),
            possibleItemTexts: JSON.parse(JSON.stringify(possibleItemTexts)),
            instructions: this.getInstructions(1, endUser, item),
            itemInstructions: this.getInstructions(0, endUser, item),
            orderItems: [],
            fsc: item.value.FSC,
            cw_mark: item.value.CW_MARK,
            pefc: item.value.PEFC,
            cancelledOrder: false
        });
        
    }

    getselectedDeliveryCodeValue(item) {
        return this.getLabelAndValueForCodeAndDescription(item && item.value, this.state.deliveryCodes, "DELIVERY_CODE");
    }

    getdiscountDescriptionValue(item) {
        return item && item.value && item.value.CASH_DISCOUNT_CODE && (item.value.CASH_DISCOUNT_CODE + ' - ' + item.value.DISC_DESCRIPTION);
    }

    // handleDeliveryCodeSelectChange(item) {
    //     let newValue = this.getLabelAndValueForCodeAndDescription(this.state.selectedCustomerValue.value, this.state.deliveryCodes, "DELIVERY_CODE");
    //     if (item && item.value && item.value && item.value !== newValue) {
    //         newValue = this.getLabelAndValueForCodeAndDescription(item.value, this.state.deliveryCodes, "CODE", true);
    //     }
    //     this.setState({ selectedDeliveryCodeValue: newValue });
    // }

    // handleCurrencySelectChange(item){        
    //     let newValue=this.getLabelAndValueForCodeAndDescription(this.state.selectedCustomerValue.value,this.state.currencies,"CURRENCY_CODE", false);
    //     if (item  && item.value && item.value && item.value!==newValue)
    //     {
    //         newValue=this.getLabelAndValueForCodeAndDescription(item.value,this.state.currencies, "CODE",false);
    //     }
    //     this.setState({selectedCurrencyValue: newValue}) ;
    // }       

    getcombo(_caption, _stateObj, _onChange, _placeHolder, _options, _clearable = true, disabled = false, _valueMinWidth = '260px') {

        return (
            <FormGroup className="select">
                <InputGroup className="margin-left-10 margin-top-4" bsSize="sm"><InputGroup.Addon>{_caption}</InputGroup.Addon>
                    <Select isSearchable={true} isClearable={_clearable} resetValue=''
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                minHeight: '25px',
                                height: '32px'
                            }),
                            valueContainer: (provided) => ({
                                ...provided,
                                height: '32px',
                                minWidth: '260px'
                            }),
                            indicatorsContainer: (provided) => ({
                                ...provided,
                                height: '32px',
                            }),
                        }}
                        isDisabled={disabled}
                        value={this.state[_stateObj] || ''} onChange={(item) => _onChange(item, _stateObj)}
                        options={_options} placeholder={_placeHolder} />
                </InputGroup>
            </FormGroup>
        );
    }


    getinfo(_caption, _stateObj, _readonly = false, _multirow = false, _width = "auto", dobreak = false, _height = "", maxlen = null) {
        let clname = dobreak ? " col-lg-1" : "";
        let clname2 = "margin-left-10 margin-top-4" + clname;
        return (

            <FormGroup bsSize="sm">
                <InputGroup className={clname2} bsSize="sm"><InputGroup.Addon className={clname}>{_caption}</InputGroup.Addon>
                    <FormControl
                        bsSize="sm"
                        componentClass={_multirow ? "textarea" : "input"}
                        style={{ width: _width, height: _height }}
                        readOnly={_readonly}
                        tabIndex={_readonly ? -1 : null}
                        value={this.state[_stateObj] || ''}
                        title={this.state[_stateObj]}
                        placeholder={_readonly ? '' : _caption}
                        maxLength={maxlen}
                        onChange={(e) => this.setState({ [_stateObj]: e.target.value })}
                    />
                </InputGroup>
            </FormGroup>
        );
    }

    getinfoFromVariable(_caption, _variable, _multirow = false, _width = "auto", dobreak = false, _height = "") {
        let clname = dobreak ? " col-lg-1" : "";
        let clname2 = "margin-left-10 margin-top-4" + clname;
        return (

            <FormGroup bsSize="sm">
                <InputGroup className={clname2} bsSize="sm"><InputGroup.Addon className={clname}>{_caption}</InputGroup.Addon>
                    <FormControl
                        bsSize="sm"
                        componentClass={_multirow ? "textarea" : "input"}
                        style={{ width: _width, height: _height, textAlign: "center" }}
                        readOnly={true}
                        value={_variable}
                        title={_variable}
                    />
                </InputGroup>
            </FormGroup>
        );

    }


    getinfoFromRecord(_caption, _fieldname, _customer, _multirow, _width = "auto") {
        let txt = (_customer && _customer.value && _customer.value[_fieldname]) || '';
        return (
            <FormGroup bsSize="sm">
                <InputGroup className="margin-left-10 margin-top-4" bsSize="sm"><InputGroup.Addon>{_caption}</InputGroup.Addon>
                    <FormControl
                        bsSize="sm"
                        readOnly={true}
                        tabIndex={-1}
                        componentClass={_multirow ? "textarea" : "input"}
                        style={{ width: _width }}
                        value={txt}
                        title={txt}
                    />
                </InputGroup>
            </FormGroup>
        );
    }

    getvalueFromState(_stateObj, self) {
        return (this.state[_stateObj] !== undefined && this.state[_stateObj]);
    }

    getCheckBox(_caption, _stateObj, _readonly = false) {
        let wood = "";

        if (_caption == "Call Off") {
            let codes = [];
            if (this.state.fsc)
                wood += "FSC, ";
            if (this.state.pefc)
                wood += "PEFC, ";
            if (this.state.cw_mark)
                wood += "CW, ";
            wood = wood.substring(0, wood.length - 2);
        }
        return (
            <FormGroup bsSize="sm">
                <InputGroup className="margin-left-10 margin-top-4" bsSize="sm"><InputGroup.Addon>{_caption}</InputGroup.Addon>
                    <Checkbox className="checkbox"
                        bsSize="sm"
                        checked={this.getvalueFromState(_stateObj, this)}
                        onChange={(e) => {
                            if (!_readonly) {
                                this.setState({ [_stateObj]: e.target.checked })
                            }
                        }
                        }
                    />{_caption == "Call Off" &&
                        <div className="margin-left-10" style={{ display: "inline-flex" }}>
                            <FormControl
                                bsSize="sm"
                                readOnly={true}
                                tabIndex={-1}
                                componentClass={"input"}
                                style={{ width: "105px", visibility: wood.length > 0 ? "visible" : "hidden" }}
                                value={wood}
                                title={wood}
                            />
                        </div>
                    }
                </InputGroup>
            </FormGroup>
        );
    }


    refresh() {
        this.setState({});
    }

    GAtrackHandler(e, r) {
        ReactGA.event({
            category: "User action",
            action: e ? "User created an order " + r ? " and released it" : " and saved it" : "User creaded an order but cancelled it",
        });
    }

    render() {
        if (this && this.dialog)
            var dia = this.dialog;
        let id = this.props.id;
        let cmd = this.props.cmd;
        let data = this.state.orderItems;
        let legalEntity = this.state.legalEntity;
        if (data && this && this.state && this.state.productCodes) {
            let codes = this.state.productCodes;
            let passiveProducts = new Array();
            let missingProducts = new Array();
            let missingCoreProducts = new Array();
            data.forEach(function (oi) {
                let hit = false;
                codes.forEach(function (pc) {
                    if (oi.PRODUCT_CODE === pc.PRODUCT_CODE) {
                        hit = true;
                        if (!pc.IS_ACTIVE) {
                            passiveProducts.push(oi.PRODUCT_CODE);
                            oi.IS_ACTIVE = false;
                        }
                        else if (!oi.PAPER_MACHINE && !pc.PAPER_MACHINE) {
                            missingProducts.push(oi.PRODUCT_CODE);
                            oi.IS_ACTIVE = false;
                        }
                        else if (oi.PRODUCT_TYPE === '0' && !oi.ROLL_CORE_FORMAT && !pc.ROLL_CORE_FORMAT) {
                            missingCoreProducts.push(oi.PRODUCT_CODE);
                            oi.IS_ACTIVE = false;
                        }
                    }


                });
                if (!hit) {
                    if (oi.PRODUCT_CODE)
                        passiveProducts.push(oi.PRODUCT_CODE);
                    oi.IS_ACTIVE = false;
                }
                hit = false;
            });
            if (passiveProducts.length > 0 || missingProducts.length > 0 || missingCoreProducts.length > 0) {
                let message = '';
                if (passiveProducts.length > 0) {
                    message = 'The following products are not active: ' + passiveProducts.join(", ") + ', please replace or remove the item(s). ';
                }
                if (missingProducts.length > 0) {
                    message = message.concat('The following products are missing a paper machine: ' + missingProducts.join(", ") + ', please contact Nordic Paper. ');
                }
                if (missingCoreProducts.length > 0) {
                    message = message.concat('The following products are missing a core: ' + missingCoreProducts.join(", ") + ', please contact Nordic Paper. ');
                }
                dia.showAlert(message);
            }
        }

        let lockComment = hasGrant(Grants.TYPES.Order_AddOrderComment) == false;
        let pCodes = this.state.productCodes && this.state.productCodes.filter(pc => pc.IS_ACTIVE);
        let priceUnit = this.state.selectedCustomerValue && this.state.selectedCustomerValue.value && this.state.selectedCustomerValue.value.PRICE_UNIT;
        let specialCodes = {
            fsc: this.state.fsc,
            pefc: this.state.pefc,
            cw_mark: this.state.cw_mark
        };
        let grid = (pCodes) ? <OrderItems disabled={this.state.disabled} parentRefresh={this.refresh} data={data} userType={this.state.userType} productCodes={pCodes} apiToken={this.props.apiToken} priceUnit={priceUnit} specialCodes={specialCodes} itemTexts={this.state.possibleItemTexts} itemInstructions={this.state.itemInstructions} deliveryTimeCodes={this.props.clientCodeList.DeliveryTimeCodes} currency={this.state.currencyValue} /> : <LoadingSpinner isLoading={true} />;

        let caption = cmd == Command.Modify ? "Modify order " + id : "Create new order";
        if (this.state.selectedCustomerValue === '') {
            grid = undefined;
        }
        let disabled = this.state.disabled;

        return (
            <div>
                <Dialog ref={(el) => { this.dialog = el }} />
                <NPSpinnerModal showModal={this.state.showSpinnerModal} title="Processing order" content={this.state.modalContent} closeAction={this.close} isLoading={this.state.saveInProgress} />
                <Row>
                    <Form inline onSubmit={evt => { evt.preventDefault(); }}>
                        <Row><div className="center-block text-center"><span style={{ "fontSize": "16px", "fontWeight": "600" }}>{caption}</span></div></Row>
                        <Col md={12} lg={12} >
                            <fieldset className="myfieldset smaller-inputs">
                                <legend className="mylegend">Client info</legend>
                                <div className="pull-Left margin-right-30">
                                    <Row><Col>{this.getcombo('Client', "selectedCustomerValue", this.handleClientSelectChange, 'Client', this.state.clientCodes, false, disabled ? disabled : cmd != Command.Create)}</Col></Row>
                                    <Row><Col>{this.getcombo('End User', "selectedEndUserValue", this.handleEndUserSelectChange, 'End User', this.state.endUserCodes, false, disabled)} </Col></Row>
                                    {/* <Row><Col>{this.getcombo('Delivery Code', "selectedDeliveryCodeValue", this.handleDeliveryCodeSelectChange, 'Delivery Code', this.state.deliveryCodes)} </Col></Row> */}
                                    <Row><Col>{this.getinfo('Delivery Code   ', 'selectedDeliveryCodeValue', true, true, "300px", false)}</Col></Row>
                                    <Row><Col>{this.getcombo('Bill To', "selectedBillToValue", this.handleSubClientSelectChange, 'Bill To', this.state.billToCodes, false, disabled)} </Col></Row>
                                    <Row><Col>{this.getcombo('Sold To', "selectedSoldToValue", this.handleSubClientSelectChange, 'Sold To', this.state.soldToCodes, false, disabled)}</Col></Row>
                                    {/* <Row><Col>{this.getinfo('Delivery Destination', 'deliveryDestinationValue', true, true, "300px", false)}</Col></Row> */}
                                    <Row><Col>{this.getinfo('Currency', 'currencyValue', true, false, "300px")}</Col></Row>
                                    {/* <Row><Col>{this.getcombo('Currency',"selectedCurrencyValue",this.handleCurrencySelectChange,'Currency',this.state.currencies, "150px")}</Col></Row>  */}
                                    <Row><Col>{this.getinfo('VAT Number', 'vatValue', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('Language', 'languageValue', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('Order Comment   ', 'commentValue', lockComment, true, "300px", false, "60px")}</Col></Row>
                                    {/* <div className="clearFix"> 
                            </div> */}
                                </div>
                                <div className="pull-Left margin-right-30">
                                    <Row><Col>{this.getcombo('Ship To', "selectedShipToValue", this.handleShipToSelectChange, 'Ship To', this.state.shipToCodes, false)} </Col></Row>
                                    <Row><Col>{this.getinfo('Company', 'shipToCompany', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('Address 1', 'shipToAddressLine1', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('Address 2', 'shipToAddressLine2', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('Address 3', 'shipToAddressLine3', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('Zip code', 'shipToZip', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('City', 'shipToCity', true, false, "300px")}</Col></Row>
                                    <Row><Col>{this.getinfo('Country', 'shipToCountry', true, false, "300px")}</Col></Row>
                                </div>
                                <div className="pull-Left margin-right-30">
                                    <Row><Col>
                                        <div style={{ maxWidth: "350px" }}>
                                            {this.getinfo('Payment', 'paymentDescriptionValue', true, false, "300px")}
                                            {this.getinfo('Discount', 'discountDescriptionValue', true, false, "300px")}
                                            {this.getinfo('Format Unit', 'formatUnitValue', true, false, "300px")}
                                            {/* {this.getcombo('Format Unit',"selectedFormatUnitValue",this.handleComboChange,'Format Unit',[{label:'mm',value:"mm"},{label:'inch',value:"inch"}], "300px",true)} */}
                                            {this.getinfo('Agent Ref', 'salesAgentRef', disabled, false, "300px")}
                                            {this.getinfoFromRecord('Sales Agent 1', 'SALES_AGENT', this.state.selectedCustomerValue, false, "300px")}
                                            {this.getinfoFromRecord('Sales Agent 2', 'SALES_AGENT2', this.state.selectedCustomerValue, false, "300px")}
                                            {hasGrant(Grants.TYPES.Order_ToggleCallOff) && this.getCheckBox("Call Off", 'callOffValue')}
                                            {this.getinfo('Customer PO', 'customerPO', disabled, false, "300px", false, "", 25)}
                                        </div>
                                    </Col>
                                    </Row>
                                </div>



                            </fieldset>
                        </Col>

                        <Col md={12}>
                            <fieldset className={"myfieldset form form-vertical " + (this.state.otherInfoCollapsed ? 'collapsed' : '')}>
                                <legend className="mylegend clickable" onClick={() => { this.setState({ otherInfoCollapsed: !this.state.otherInfoCollapsed }) }}>
                                    {this.state.otherInfoCollapsed && <Glyphicon glyph="triangle-bottom" />}
                                    {!this.state.otherInfoCollapsed && <Glyphicon glyph="triangle-top" />}

                                    Confirmation info
                        </legend>

                                <div className="content">
                                    <Row>
                                        <Col xs={12}>
                                            {this.getinfo('Conf. Version', 'confirmation_Version', true, false)}
                                            {this.getCheckBox("Conf. Sent", 'confirmationSent', true)}
                                        </Col>

                                        <Col xs={12}>
                                            {this.getinfo('Mod. Date', 'oldModUserDateTime', true, false)}
                                            {this.getinfo('Mod. User', 'oldModUser', true, false)}
                                            {this.getinfo('Reg. Date', 'regUserDateTime', true, false)}
                                            {this.getinfo('Reg. User', 'regUser', true, false)}
                                        </Col>
                                    </Row>
                                </div>
                            </fieldset>
                        </Col>
                    </Form>
                    <Row>
                    </Row>
                    {hasGrant(Grants.TYPES.Order_ModifyOrderTexts) &&
                        <Col md={12}>
                            <fieldset className={"myfieldset " + (this.state.viewOrderTextsCollapsed ? 'collapsed' : '')}>
                                <legend className="mylegend clickable" onClick={() => { this.setState({ viewOrderTextsCollapsed: !this.state.viewOrderTextsCollapsed }) }}>
                                    {this.state.viewOrderTextsCollapsed && <Glyphicon glyph="triangle-bottom" />}
                                    {!this.state.viewOrderTextsCollapsed && <Glyphicon glyph="triangle-top" />}

                                    Order texts
                            </legend>

                                <div className="content" style={{ overflowX: "scroll" }}>
                                    <OrderTexts orderTexts={this.state.possibleTexts} isDetail={0} isHeader={1} disabled={disabled} />
                                </div>
                            </fieldset>
                        </Col>
                    }
                    <Col sm={12}>
                        <Form>
                            <FormGroup>

                                <fieldset className="myfieldset">
                                    <legend className="mylegend">
                                        Order
                                </legend>

                                    <Row className="unflow-table">
                                        <Col xs={12}>
                                            {grid}
                                        </Col>
                                    </Row>
                                </fieldset>

                                <Row className="margin-top-10">
                                    <Col xs={12}>
                                        <Button bsStyle="primary" disabled={this.notOkToSave(this.state)} onClick={evt => { this.save(this, false); }}>
                                            Save
                                    </Button>
                                        <Button bsStyle="primary" disabled={this.notOkForRelease()} className="margin-left-10" onClick={evt => { this.save(this, true); }}>
                                            Save and release
                                    </Button>
                                        <Button bsStyle="primary" onClick={this.close} className="margin-left-10">
                                            Close
                                    </Button>
                                        <Button bsStyle="primary" disabled={this.notOkToCancel()} onClick={evt => {this.showCancelDialog(this); }} className="pull-right">
                                            Cancel order
                                    </Button>
                                    </Col>
                                </Row>

                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default OrderCreate;